module.exports = __webpack_public_path__ + "6c8863f0c4fe47a9abbb59d80c6d481e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/chuong-trinh-khuyen-mai.svg
// module id = ./assets/images/chuong-trinh-khuyen-mai.svg
// module chunks = 0